function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M264.886 315.14V147.218C339.504 147.218 400 207.713 400 282.332V315.14C400 321.471 394.872 326.599 388.541 326.599H276.345C270.021 326.599 264.886 321.471 264.886 315.14Z",
  fill: "#359CDD"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M153.291 123.648V11.4589C153.291 5.12784 158.426 0 164.75 0H264.886C339.511 0 400 60.4884 400 135.114V270.221C400 195.603 339.504 135.107 264.886 135.107H164.75C158.426 135.107 153.291 129.979 153.291 123.648Z",
  fill: "#359CDD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M135.114 11.4589V179.381C60.4957 179.381 0 118.886 0 44.267V11.4589C0 5.12784 5.12784 0 11.4589 0H123.655C129.979 0 135.114 5.12784 135.114 11.4589Z",
  fill: "#359CDD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M246.709 202.951V315.14C246.709 321.471 241.574 326.599 235.25 326.599H135.114C60.4885 326.599 0 266.11 0 191.485V56.3776C0 130.996 60.4957 191.492 135.114 191.492H235.25C241.574 191.492 246.709 196.62 246.709 202.951Z",
  fill: "#359CDD"
});

function SvgLogoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 327,
    viewBox: "0 0 400 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.aed5002c.svg";
export { ForwardRef as ReactComponent };